export default {
  login: '',
  password: '',
  captchaVerified: false
};



// WEBPACK FOOTER //
// ./src/containers/Login/formValues.js